/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_sport = /** @type {(inputs: {}) => string} */ () => {
	return `Sport`
};

const da_attributes_sport = /** @type {(inputs: {}) => string} */ () => {
	return `Sport`
};

const de_attributes_sport = /** @type {(inputs: {}) => string} */ () => {
	return `Sport`
};

const en_attributes_sport = /** @type {(inputs: {}) => string} */ () => {
	return `Sport`
};

const es_attributes_sport = /** @type {(inputs: {}) => string} */ () => {
	return `Sport`
};

const fr_attributes_sport = /** @type {(inputs: {}) => string} */ () => {
	return `Sport`
};

const hu_attributes_sport = /** @type {(inputs: {}) => string} */ () => {
	return `Sport`
};

const it_attributes_sport = /** @type {(inputs: {}) => string} */ () => {
	return `Sport`
};

const nl_attributes_sport = /** @type {(inputs: {}) => string} */ () => {
	return `Sport`
};

const pl_attributes_sport = /** @type {(inputs: {}) => string} */ () => {
	return `Sport`
};

const pt_attributes_sport = /** @type {(inputs: {}) => string} */ () => {
	return `Sport`
};

const sv_attributes_sport = /** @type {(inputs: {}) => string} */ () => {
	return `Sport`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_sport = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_sport(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_sport", locale)
	if (locale === "cs") return cs_attributes_sport(inputs)
	if (locale === "da") return da_attributes_sport(inputs)
	if (locale === "de") return de_attributes_sport(inputs)
	if (locale === "en") return en_attributes_sport(inputs)
	if (locale === "es") return es_attributes_sport(inputs)
	if (locale === "fr") return fr_attributes_sport(inputs)
	if (locale === "hu") return hu_attributes_sport(inputs)
	if (locale === "it") return it_attributes_sport(inputs)
	if (locale === "nl") return nl_attributes_sport(inputs)
	if (locale === "pl") return pl_attributes_sport(inputs)
	if (locale === "pt") return pt_attributes_sport(inputs)
	return sv_attributes_sport(inputs)
};
export { attributes_sport as "attributes.sport" }